import { useState, useEffect, useMemo } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Table, Collapse, Button, Spinner, FormGroup, Label, Input } from 'reactstrap';
import './Biodiversity.css';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import { FaChevronUp, FaChevronDown, FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import uuid from 'react-uuid';
import MapView from '../Map/MapView';
import ToggleSwitch from '../ThreeStateToggle/ToggleSwitch';
import BioDiversityItemView from './BioDiversityItemView';
import { useNavigate } from "react-router-dom";
import Documents from '../Uploads/Documents';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html"; import { apiGet,apiPost } from "../Utilities/Hooks/apiWrapper";

const Biodiversity = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage }) => {
    const roleName = localStorage.getItem("roleName"); const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false);
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId")); const [toggleSwitch, setToggleSwitch] = useState('map & details');
    const [loading, setLoading] = useState(true);
    const [itemList, setItemList] = useState([]);
    const [biodiversity, setBiodiversity] = useState({ outlineList: [], itemList: [], SectionName: 'Biodiversity', Section: 'Biodiversity', isWizardCompleted: false, sectionObj: {}, sectionComment: '' });
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false, isFarmOutlineEditable: false, zoomLevel: 15,
        polyType: '', itemsEditable: false, highlighteditemId: 0, isClear: false
    });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0 })
    const [isOpen, setIsOpen] = useState(true); const [isIconUp, setIsIconUp] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setBiodiversity({ ...biodiversity, sectionComment: value })
    }
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const navigate = useNavigate();
    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/biodiversity/GetBiodiversity/', {
                params: {
                    farmId: farmId
                }
            }
            );
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.section.routePath);
                if (section.length > 0) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            setBiodiversity({
                ...biodiversity, outlineList: response.data.outlineList, itemList: response.data.itemList, isWizardCompleted: response.data.isFWFPCompleted, sectionObj: response.data.section, sectionComment: response.data.sectionComment
            });
            setItemList(response.data.itemList);
            setShow_HistoricalActions(response.data.show_HistoricalActions);
            setShow_SectionComment(response.data.show_SectionComment);
            const content = ContentState.createFromBlockArray(convertFromHTML(response.data.sectionComment == null ? '' : response.data.sectionComment))
            setEditorState(EditorState.createWithContent(content));
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, polyType: '' });
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            setLoading(false);
        } catch (err) {
            console.log(err);
        }
    }

    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '95vw' : '50vw'}
                height={toggleSwitch == 'map' ? '95vw' : '50vw'}
                itemModel={biodiversity}
                mapDetails={mapDetails}
                largeEnterpriseDetails={largeEnterpriseDetails}>
            </MapView>
        )
    }, [biodiversity, mapDetails, largeEnterpriseDetails, toggleSwitch])

    const handleItemView = (itemId, routePath) => {
        navigate('/' + routePath, { state: { itemId: itemId, navigateFrom: 'Biodiversity' } });
    }

    const itemView = useMemo(() => {
        return (
            <Table bordered>
                <thead>
                    <tr>
                        <th>Icon</th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Description</th>
                        <th>View</th>
                    </tr>
                </thead>
                <tbody>
                    {itemList == undefined &&
                        <Spinner color="success"> Loading... </Spinner>
                    }
                    {itemList != undefined && itemList != null && itemList.map(item => (
                        <BioDiversityItemView key={uuid()} item={item} handleItemHighlight={handleItemHighlight} handleItemView={handleItemView}></BioDiversityItemView>
                    ))}
                </tbody>
            </Table>
        )
    }, [itemList])

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }

    const CustomToastWithLink = () => (
        <div>
            <p>At times you’ll add an item and, in the pop-up form, there is a tick box that you can use to indicate that the item adds to the farm’s biodiversity. If the tick box is activated this item will automatically appear on the biodiversity page. This will only occur if you select the biodiversity page as an optional add-on when you first set up the farm enterprise and activities (in the Enterprise and Farm Detail module).</p>
        </div>
    );
    const customId = "custom-id-yes";
    const showToastMessage = (e) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink, {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };
    const handlePageChange = async (section, method) => {
        await SaveSectionComment();
        if (method == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }
    const SaveSectionComment = async () => {
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/biodiversity/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
        } catch (err) {
            console.log(err);
        }
    }
    const [savingSectionComment, setSavingSectionComment] = useState('');
    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/biodiversity/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{biodiversity.SectionName}</h3></Col>
                { !loading &&
                    <Col>
                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(biodiversity.Section,'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        {roleName != 'Admin' && saveRightsForNonItemFieldsAndTables == 'false' && isNextButtonVisible &&
                            <>
                            <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(biodiversity.Section,'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                            </>
                        }
                        <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(biodiversity.Section,'handleWizardChangedBack')}>Back <FaChevronLeft /> </Button>
                    </Col>
                }
            </Row>
            {
                loading ? <SpinnerContainer /> :
                    <div>
                        <Row style={{ marginTop: '10px' }}>
                            <Col id='mapView'>
                                <Row className="map-layer" style={{ marginTop: '10px' }}>
                                    <Col>
                                        <Row>
                                            <Col sm="3"> {toggleSwitch == 'map & details' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_expand.png" className="card_icon" ></img>
                                                </Button>
                                            }
                                                {toggleSwitch == 'map' &&
                                                    <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                        <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>
                                        {mapView}
                                    </Col>
                                </Row>
                            </Col>
                            <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', }}>
                                <Row style={{ marginTop: '10px' }}>
                                    <Col sm="3">
                                        {toggleSwitch == 'map & details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                                <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                        {toggleSwitch == 'details' &&
                                            <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#0d535d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                                <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                                {show_SectionComment &&
                                    <>
                                        <Row style={{ marginTop: "0.5vh" }}>
                                            <Col sm="12">
                                                <FormGroup>
                                                    <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "16px" }}><b>Section Comment</b> <span className="text-lowercase">(add any information around the features, actions, or risks, that have been considered on this page)</span></Label>
                                                <Editor handlePastedText={() => false} spellCheck={true}
                                                        defaultEditorState={editorState}
                                                        onEditorStateChange={setEditorState}
                                                        wrapperClassName="wrapper-class"
                                                        editorClassName="editor-class"
                                                        toolbarClassName="toolbar-class"
                                                        toolbar={
                                                            {
                                                                options: ['inline'], inline: {
                                                                    inDropdown: false,
                                                                    options: ['bold', 'italic', 'underline'],
                                                                }
                                                            }
                                                        }
                                                    />
                                                </FormGroup>

                                            </Col>
                                            <Col sm="12">
                                                {savingSectionComment ?
                                                    <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                                        <Row>
                                                            <Col sm="8">
                                                                <span>
                                                                    {' '}Saving
                                                                </span>
                                                            </Col>
                                                            <Col sm="4">
                                                                <Spinner size="sm">
                                                                    Saving...
                                                                </Spinner>
                                                            </Col>
                                                        </Row>
                                                    </Button>
                                                    :
                                                    <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                                        Save
                                                    </Button>
                                                }
                                            </Col>
                                        </Row>
                                        <br />
                                    </>
                                }
                                <Row >
                                    <Col>
                                        <Card className="cardNonLeftRadius">
                                            <CardHeader className="header" onClick={toggle}>
                                                <Row>
                                                    <Col sm="11"><span className="text-uppercase fw-bold color-dark-teal">Biodiversity currently on the property&nbsp;&nbsp;&nbsp;
                                                        <img className="featureIcon" src="/images/info_button_dk.png" data-tooltip-id="my-tooltip-32" onClick={(e) => e.stopPropagation()} /></span>
                                                        <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                                            id="my-tooltip-32"
                                                            place="top"
                                                            variant="info"
                                                            render={({ content, activeAnchor }) => (
                                                                <>
                                                                    <Row>
                                                                        <Col>
                                                                            <p style={{ fontWeight: "lighter" }}>
                                                                                For more information on Biodiversity <a href="https://freshwaterfarmplan.co.nz/support-category/biodiversity/" target="_blank" rel="noreferrer">Click Here</a>
                                                                            </p>
                                                                        </Col>
                                                                    </Row>
                                                                </>
                                                            )}
                                                        />
                                                    </Col>
                                                    <Col sm="1" className="toggleoutline_lt">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                                                </Row>
                                            </CardHeader>
                                            <Collapse isOpen={isOpen}>
                                                <CardBody>
                                                    {itemView}

                                                    {/*Document Upload*/}
                                                    {
                                                        biodiversity.sectionObj.isDocumentUploadReq && <Documents refid={biodiversity.sectionObj.id} uploadType="Section" open={false} showArrow={true}></Documents>
                                                    }
                                                </CardBody>
                                            </Collapse>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div> 
            }
        </div>
    )
}
export default Biodiversity;